import { Component, computed, inject, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@openng/optimus-ui/tabs';
import { MessageTypeEnum } from '@libs/types/src/user/enum/message-type.enum';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { GlobalStore } from '../../../../../../store/global.global-store';
import {
    MessageRecipientDetailPageComponent,
} from '../../../profile-page/profile-messages/message-recipient-detail-page/message-recipient-detail-page.component';
import {
    MessageRecipientsTableComponent,
} from '../../../../../../components/system-setting/message/message-recipients-table/message-recipients-table.component';

@Component({
    selector: 'app-user-message-dialog-widget',
    templateUrl: './user-message-dialog-widget.component.html',
    imports: [
        TranslatePipe,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        MessageRecipientDetailPageComponent,
        MessageRecipientsTableComponent,
    ],
})
export class UserMessageDialogWidgetComponent extends BaseDialogComponent {

    private readonly globalStore = inject(GlobalStore);

    protected readonly id: number | null = this.dialogConfig?.data?.id ?? null;

    protected selectedTab = 'message';

    private readonly detailRef = viewChild<MessageRecipientDetailPageComponent>('detail');

    protected readonly showTabs = computed<boolean>(() => {
        const recipient = this.detailRef()?.recipient();
        if (recipient?.message?.type !== MessageTypeEnum.SERVICE_MESSAGE) {
            return false;
        }
        return !!this.globalStore.isAllowed('serviceMessage.read')();
    });

    protected readonly messageId = computed<number | null>(
        () => this.detailRef()?.recipient()?.message?.id ?? null,
    );
}
